const doc = [({"en":({"js":({"admin":({"sending_rules":({"table":({"the_sending_rule_was_deleted":"The sending rule was deleted"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;